import { render, staticRenderFns } from "./PzDocusign.vue?vue&type=template&id=3a60f2f6&scoped=true"
import script from "./PzDocusign.vue?vue&type=script&lang=js"
export * from "./PzDocusign.vue?vue&type=script&lang=js"
import style0 from "./PzDocusign.vue?vue&type=style&index=0&id=3a60f2f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60f2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a60f2f6')) {
      api.createRecord('3a60f2f6', component.options)
    } else {
      api.reload('3a60f2f6', component.options)
    }
    module.hot.accept("./PzDocusign.vue?vue&type=template&id=3a60f2f6&scoped=true", function () {
      api.rerender('3a60f2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Docusign/PzDocusign.vue"
export default component.exports